// CRM C-I: die Signatur so zeigen, wie sie beim Empfaenger ankommt.
//
// WARUM EIN IFRAME UND KEIN `div`: eine Outlook-Signatur bringt ihre eigene Schrift,
// Groesse und Abstaende mit — 12pt Aptos, `margin:0` je Absatz. Steht sie im DOM der
// Seite, zieht Bootstrap sie auf seine Werte um (`font-size:.875rem`, eigene
// Zeilenhoehe, `p {margin-bottom:1rem}`), und die Vorschau zeigt etwas anderes als das,
// was gesendet wird. Im iframe gilt nur, was in der Signatur steht.
//
// Der zweite Grund ist derselbe wie bei `EmailFullBody`: der Inhalt kann aus einer
// GETEILTEN Vorlage eines anderen Nutzers stammen. `sanitizeHtml` ist die erste Grenze,
// das abgeschottete Dokument die zweite.
import React, { useCallback, useState } from "react";

import { sanitizeHtml } from "./emailHtml";

/**
 * Kein Rahmen, kein Innenabstand, keine eigene Schrift: was das Dokument hier setzen
 * wuerde, waere genau der Unterschied zu Outlook, den es zu vermeiden gilt. Die CSP
 * steht im Dokument, weil `srcdoc` keine eigenen Antwortkoepfe hat.
 */
export const signatureDocument = (html) => `<!doctype html>
<html><head>
<meta charset="utf-8">
<meta http-equiv="Content-Security-Policy" content="default-src 'none'; style-src 'unsafe-inline'; img-src data: https:;">
<base target="_blank">
<style>html,body{margin:0;padding:0;background:transparent;overflow:hidden;}img{max-width:100%;}table{max-width:100%;}</style>
</head><body>${html}</body></html>`;

/**
 * ponytail: Hoehe einmal beim Laden messen statt eines ResizeObservers. Der Inhalt ist
 * statisch — er aendert sich nur, wenn ein neues `html` hereinkommt, und dann laedt das
 * Dokument ohnehin neu. Ceiling: nachladende Fernbilder koennen die Hoehe spaeter
 * aendern; dann waere ein `load`-Ereignis pro Bild noetig.
 *
 * `allow-same-origin` ist noetig, um die Hoehe ueberhaupt lesen zu koennen, und hier
 * ungefaehrlich: ohne `allow-scripts` laeuft in dem Dokument kein Skript, und die CSP
 * verbietet es ein zweites Mal.
 */
const SignaturePreview = ({ html, className, title }) => {
  const [height, setHeight] = useState(80);

  const measure = useCallback((event) => {
    const doc = event.target.contentDocument;
    // +2: die gemessene Hoehe passt exakt — ein halbes Pixel Rundung genuegt sonst
    // fuer einen Balken im iframe NEBEN dem des Rahmens.
    if (doc) setHeight(Math.max(24, doc.documentElement.scrollHeight + 2));
  }, []);

  return (
    <iframe
      title={title || "Signatur"}
      className={className}
      // Der iframe scrollt NIE: er ist so hoch wie sein Inhalt, gescrollt wird am
      // Rahmen darum. Sonst stehen zwei Balken nebeneinander — Word-Signaturen bringen
      // Tabellen mit fester pt-Breite mit, deren Querbalken frisst Hoehe und loest
      // prompt auch noch den senkrechten aus.
      scrolling="no"
      sandbox="allow-same-origin"
      srcDoc={signatureDocument(sanitizeHtml(html))}
      onLoad={measure}
      style={{ width: "100%", height, border: 0, display: "block", colorScheme: "light" }}
    />
  );
};

export default SignaturePreview;
